<template>
  <div class="bg-white rounded-xl !pb-3">
    <section
      class="all-documents-view !mb-2 heightClass overflow-y-auto overflow-x-hidden !rounded-xl"
      id="company-documents-list"
    >
      <div
        class="flex items-start lg:!items-center justify-between px-3 py-2 border-b !border-[#E0E5EB] flex-col lg:!flex-row !gap-3 sticky top-0 bg-white z-[1]"
      >
        <div class="flex items-center !gap-3">
          <h3
            class="!text-sm 2xl:!text-base !font-normal !text-black-950 !m-0 !max-w-64 2xl:!max-w-[500px] truncate"
          >
            Documents
          </h3>

          <div v-if="!getIsMobile" class="flex items-center !gap-3">
            <el-dropdown class="" v-if="this.selected_document.length">
              <el-button size="mini" class="el-dropdown-link px-2">
                Delete
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <a
                  v-if="this.$route.query.type && this.$route.query.type == 'deleted'"
                  @click="checkCondition"
                >
                  <el-dropdown-item>
                    <i class="el-icon-delete-solid"></i>
                    <span>Permanent Delete</span>
                  </el-dropdown-item>
                </a>
                <a v-else @click="checkCondition">
                  <el-dropdown-item>
                    <i class="el-icon-delete"></i>
                    <span>Delete</span>
                  </el-dropdown-item>
                </a>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="flex items-center !gap-3 flex-wrap">
          <div v-if="selectedFilter == 'custom_date'">
            <el-date-picker
              placeholder="Pick a day"
              type="date"
              v-model="selectedDate"
            ></el-date-picker>
          </div>
          <div v-if="selectedFilter == 'custom_date_range'">
            <el-date-picker
              type="daterange"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              v-model="selectedDateRange"
            ></el-date-picker>
          </div>
          <div
            v-if="
              (selectedFilter && !selectedStatus) ||
              (selectedFilter &&
                selectedStatus &&
                (selectedStatus === 'sent-docs' || selectedStatus === 'completed'))
            "
            class="flex items-center !gap-3 flex-wrap"
          >
            <el-tooltip
              content="Download documents details as an Excel file, if no selected status filter is selected, only sent and completed statuses within the specified time period will be included."
              placement="top-start"
              v-if="
                (selectedFilter && !selectedStatus) ||
                (selectedFilter &&
                  selectedStatus &&
                  (selectedStatus === 'sent-docs' || selectedStatus === 'completed'))
              "
            >
              <a @click="checkExportDocuments = true">
                <el-button style="height: 32px !important">
                  <span class="create-contact">
                    Export Data
                    <i class="el-icon-document"></i>
                  </span>
                </el-button>
              </a>
            </el-tooltip>
          </div>
          <div v-if="this.getActiveWorkspace && !this.isIndividualWorkspace">
            <el-select
              v-model="selectedFilter"
              filterable
              clearable
              class="select"
              placeholder="Filter by Time Period"
              :style="getIsMobile ? 'width:130px;' : 'width:180px;'"
            >
              <el-option
                v-for="(status, index) in filterByOption"
                :key="index"
                :value="status.value"
                :label="status.name"
              ></el-option>
            </el-select>
          </div>

          <div
            v-if="
              this.$route &&
              this.$route.query &&
              this.$route.query.type &&
              this.$route.query.type == 'company-documents' &&
              checkPermissionByPermissionName('viewDocument') &&
              !getIsMobile
            "
          >
            <el-select
              v-model="selected_company_user"
              size="medium"
              filterable
              clearable
              class="select"
              placeholder="Select Company User"
            >
              <el-option
                v-for="(status, index) in companyUsers"
                :key="index"
                :value="status.first_name + ' ' + status.last_name"
                :label="status.first_name + ' ' + status.last_name"
              ></el-option>
            </el-select>
          </div>
          <div
            v-if="this.getActiveWorkspace && this.isIndividualWorkspace"
            style="text-align: right"
          >
            <el-select
              v-model="selectedFilter"
              filterable
              clearable
              class="select"
              placeholder="Filter by Time Period"
            >
              <el-option
                v-for="(status, index) in filterByOption"
                :key="index"
                :value="status.value"
                :label="status.name"
              ></el-option>
            </el-select>
          </div>

          <div
            v-if="this.getActiveWorkspace && this.isIndividualWorkspace"
            :xl="4"
            :lg="4"
            :md="6"
            :sm="12"
            :xs="12"
            style="text-align: right"
          >
            <el-select
              v-model="selectedStatus"
              filterable
              clearable
              class="select"
              placeholder="Select Status"
            >
              <el-option
                v-for="(status, index) in statusOptionIndividual"
                :key="index"
                :value="status.value"
                :label="status.name"
              ></el-option>
            </el-select>
          </div>

          <div v-else>
            <el-select
              v-model="selectedStatus"
              filterable
              clearable
              class="select"
              placeholder="Select Status"
              :style="getIsMobile ? 'width:130px;' : 'width:170px;'"
            >
              <el-option
                v-for="(status, index) in statusOption"
                :key="index"
                :value="status.value"
                :label="status.name"
              ></el-option>
            </el-select>
          </div>

          <div v-if="getIsMobile">
            <el-input
              class="search px-0"
              placeholder="Search"
              v-model="search_string"
              clearable
              :style="getIsMobile ? 'width:130px;' : ''"
            ></el-input>
          </div>
          <div v-else :xl="4" :lg="4" :md="6" :sm="12" :xs="12" style="text-align: right">
            <el-tooltip placement="top" :hide-after="2000">
              <div slot="content">
                You can search by first name, last name,email, and
                <br />
                address that are present in the document users.
              </div>
              <el-input
                class="search px-0"
                placeholder="Search"
                prefix-icon="el-icon-search"
                size="small"
                v-model="search_string"
                clearable
                :style="getIsMobile ? 'width:100px' : 'width:170px;'"
              ></el-input>
            </el-tooltip>
          </div>
          <div v-if="checkPermissions('createNewDocument')">
            <el-button
              class="!py-1.5 !px-3 !border-brand-500 !rounded-sm !bg-brand-500 hover:!bg-brand-500 flex items-center !gap-2"
              type="button"
              @click="goToCreateDocument"
            >
              <span class="flex items-center !gap-1.5">
                <img src="@/assets/img/icons/new/add-icon.svg" alt="" class="!size-3" />
                <span
                  class="text-xs font-light text-white"
                  :class="getIsMobile ? 'hidden-sm-and-down' : ''"
                >
                  Create Document
                </span>
              </span>
            </el-button>
          </div>
        </div>
      </div>
      <div class="!px-3">
        <DocumentsList
          page_size="10"
          :selectedDocStatus="selectedStatus"
          :search_string="search_string"
          :selectedFilter="selectedFilter"
          :selectedDate="selectedDate"
          :selectedDateRange="selectedDateRange"
          :selected_company_user="selected_company_user"
          @deleteEvent="fetchingSelectedDelete"
        ></DocumentsList>
      </div>
      <dialog-component
        class="DialogueStyle"
        :title="'Warning'"
        :visible="centerDialogVisible"
        :containerWidth="getIsMobile ? '100%' : '25%'"
        @before-close="centerDialogVisible = false"
      >
        <span v-if="this.selected_document.length == 1">
          Are you sure you want to delete 1 selected Document?
        </span>
        <span v-if="this.selected_document.length == 0 || this.selected_document.length > 1">
          Are you sure you want to delete {{ this.selected_document.length }} selected Documents?
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">Cancel</el-button>
          <el-button type="primary" @click="selectedDocumentDelete">Confirm</el-button>
        </span>
      </dialog-component>
      <dialog-component
        class="DialogueStyle"
        :title="'Warning'"
        :visible="dialogVisibility"
        :containerWidth="getIsMobile ? '100%' : '30%'"
        :containerHeight="'180px'"
        @before-close="dialogVisibility = false"
        center
      >
        <div v-if="this.selected_document.length >= 1" class="mt-4">
          Only Document Owner can delete selected documents.
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibility = false">Cancel</el-button>
          <el-button type="primary" @click="dialogVisibility = false">Ok</el-button>
        </span>
      </dialog-component>
      <dialog-component
        class="checkExportDocuments"
        title="Export Documents Options"
        :visible="checkExportDocuments"
        :containerWidth="getIsMobile ? '100%' : '30%'"
        @before-close="documentActionModal = false"
      >
        <div>
          <el-checkbox v-model="export_all_sent_docs">
            Include all Sent Documents in Export
          </el-checkbox>
          <el-checkbox v-model="export_all_received_docs">
            Include all Received Documents in Export
          </el-checkbox>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="checkExportDocuments = false">Cancel</el-button>
          <el-button
            type="primary"
            :disabled="!export_all_sent_docs && !export_all_received_docs"
            @click="exportDocuments"
          >
            Export
          </el-button>
        </span>
      </dialog-component>
    </section>
  </div>
</template>

<script>
  import { bus } from '../../main';
  import { mapGetters } from 'vuex';
  import DocumentsList from '@/components/companyDocuments/DocumentsList';
  import PermissionsHelper from '@/mixins/permissionsHelper';
  import { postAPICall } from '../../helpers/httpHelper';
  export default {
    name: 'companyDocuments-AllDocuments',
    props: ['pageSizes', 'type', 'categoryId', 'groupId'],
    components: { DocumentsList },
    data() {
      return {
        export_all_sent_docs: true,
        export_all_received_docs: true,
        checkExportDocuments: false,
        is_documentDelete: false,
        dialogVisibility: false,
        centerDialogVisible: false,
        isVisible: false,
        selected_document: [],
        loading: false,
        search_string: '',
        editDailogVisible: false,
        selected_company_user: '',
        companyUsers: [],
        selectedCompanyDocument: '',
        total: 0,
        currentPage: 1,
        pageSize: 10,
        page: 1,
        configureLoading: false,
        openSendDocumentsModal: false,
        documentUsers: [],
        showSendDocumentoUserSettings: false,
        enforceSignatureOrder: null,
        documents: [],
        modalData: {
          document_id: '',
          name: '',
          action: '',
        },
        documentActionModal: false,
        modalLoading: false,
        selectedStatus: '',
        selectedFilter: '',
        selectedDate: '',
        selectedDateRange: '',
        selectedStatusInFilter: [
          {
            name: 'sent_docs',
            value: 'SENT',
          },
          {
            name: 'draft-docs',
            value: 'DRAFT',
          },
          {
            name: 'approved',
            value: 'APPROVED',
          },
          {
            name: 'company-documents',
            value: 'company-documents',
          },
          {
            name: 'declined',
            value: 'DECLINED',
          },
          {
            name: 'voided',
            value: 'VOIDED',
          },
          {
            name: 'deleted',
            value: 'DELETED',
          },
        ],
        filterByOption: [
          {
            name: 'Today',
            value: 'today',
          },
          {
            name: 'Yesterday',
            value: 'yesterday',
          },
          {
            name: 'This Week',
            value: 'this_week',
          },
          {
            name: 'Last Week',
            value: 'last_week',
          },
          {
            name: 'This Month',
            value: 'this_month',
          },
          {
            name: 'Last Month',
            value: 'last_month',
          },
          {
            name: 'This Quarter',
            value: 'this_quarter',
          },
          {
            name: 'Last Quarter',
            value: 'last_quarter',
          },

          {
            name: 'This Year',
            value: 'this_year',
          },
          {
            name: 'Last Year',
            value: 'last_year',
          },
          {
            name: 'Custom Date',
            value: 'custom_date',
          },
          {
            name: 'Custom Date Range',
            value: 'custom_date_range',
          },
        ],
        statusOption: [
          { name: 'Draft', value: 'draft-docs' },
          { name: 'Sent', value: 'sent-docs' },
          { name: 'Approved', value: 'approved' },
          { name: 'Company Documents', value: 'company-documents' },
          { name: 'Declined', value: 'declined' },
          { name: 'Voided', value: 'voided' },
          { name: 'Archived', value: 'deleted' },
          { name: 'Completed', value: 'completed' },
          { name: 'Waiting for Me', value: 'waiting-for-me' },
          { name: 'Waiting for Others', value: 'waiting-for-others' },
          { name: 'Expired', value: 'expired' },
          { name: 'Expiring Soon', value: 'expiring-soon' },
        ],
        statusOptionIndividual: [
          { name: 'Draft', value: 'draft-docs' },
          { name: 'Sent', value: 'sent-docs' },
          { name: 'Approved', value: 'approved' },
          { name: 'Declined', value: 'declined' },
          { name: 'Voided', value: 'voided' },
          { name: 'Archived', value: 'deleted' },
          { name: 'Completed', value: 'completed' },
          { name: 'Waiting for Me', value: 'waiting-for-me' },
          { name: 'Waiting for Others', value: 'waiting-for-others' },
          { name: 'Expired', value: 'expired' },
          { name: 'Expiring Soon', value: 'expiring-soon' },
        ],
      };
    },
    mixins: [PermissionsHelper],
    computed: {
      ...mapGetters('auth', ['getAuthenticatedUser', 'getUserType', 'getActiveWorkspace']),
      ...mapGetters('navigationOpen', ['getIsMobile', 'getIsRSOpen']),
      ...mapGetters('documents', ['getAllCompanyUsers']),
      getSelecetedDocStatus() {
        if (this.selecetedDocStatus == 'waiting') {
          return 'Need to be Sign';
        }
        return this.selecetedDocStatus;
      },
    },
    mounted() {
      if (this.$route && this.$route.query && this.$route.query.type) {
        this.selectedStatus = this.$route.query.type;
      }
      this.getCompanyUsers();
    },
    methods: {
      async exportDocuments() {
        let companyId = this.getActiveWorkspace?.company_id;
        try {
          this.downloadingFile = true;
          let selectedFilterInDocs;
          let start_date_in_docs;
          let end_date_in_docs;
          if (
            this.selectedFilter !== 'custom_date' &&
            this.selectedFilter !== 'custom_date_range' &&
            this.selectedFilter
          ) {
            selectedFilterInDocs = this.selectedFilter;
          }
          if (this.selectedFilter && this.selectedFilter == 'custom_date' && this.selectedDate) {
            selectedFilterInDocs = this.selectedFilter;
            start_date_in_docs = new Date(this.selectedDate).toISOString();
            end_date_in_docs = new Date(this.selectedDate).toISOString();
          }
          if (this.selectedFilter && this.selectedFilter == 'custom_date' && this.selectedDate) {
            selectedFilterInDocs = this.selectedFilter;
            start_date_in_docs = new Date(this.selectedDate).toISOString();
            end_date_in_docs = new Date(this.selectedDate).toISOString();
          }
          if (
            this.selectedFilter &&
            this.selectedFilter == 'custom_date_range' &&
            this.selectedDateRange
          ) {
            selectedFilterInDocs = this.selectedFilter;
            start_date_in_docs = new Date(this.selectedDateRange[0]).toISOString();
            end_date_in_docs = new Date(this.selectedDateRange[1]).toISOString();
          }
          let selectedDocStatus =
            this.selectedStatus && this.selectedStatus !== ''
              ? this.statusOptionIndividual
                  .filter((status) => status.value === this.selectedStatus)
                  .map((status) => status.name)
              : ['SENT', 'COMPLETED'];
          await postAPICall(
            'GET',
            `/export-documents?company_id=${companyId}` +
              (selectedFilterInDocs ? `&filter=${selectedFilterInDocs}` : '') +
              (start_date_in_docs ? `&start_date=${encodeURIComponent(start_date_in_docs)}` : '') +
              (end_date_in_docs ? `&end_date=${encodeURIComponent(end_date_in_docs)}` : '') +
              `&selected_status=${selectedDocStatus}&export_all_sent_docs=${this.export_all_sent_docs}&export_all_received_docs=${this.export_all_received_docs}`,
            {},
            false,
            'blob'
          ).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
              'download',
              `${this.payload?.name ? this.payload?.name : 'documents'}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            this.downloadingFile = false;
          });
          this.checkExportDocuments = false;
        } catch (err) {
          console.error('Download failed', err);
          this.downloadingFile = false;
        }
      },
      async getCompanyUsers() {
        let params = {};
        params.company_id = this.getActiveWorkspace && this.getActiveWorkspace.company_id;
        await this.$store.dispatch('documents/fetchAllCompanyUsers', params);
        let companyUserName = ' ';
        let fullName =
          this.getAuthenticatedUser.first_name + ' ' + this.getAuthenticatedUser.last_name;
        if (this.getAllCompanyUsers && this.getAllCompanyUsers.data) {
          let companyUsersData = this.getAllCompanyUsers.data;
          this.companyUsers = companyUsersData.filter((el) => {
            companyUserName = el.first_name + ' ' + el.last_name;
            return companyUserName != fullName;
          });
        }
      },
      setLoading() {
        bus.$emit('documentLoading', this.is_documentDelete);
      },
      goToCreateDocument() {
        if (!this.checkPermissionByPermissionName('createNewDocument')) {
          this.$notify.error({
            title: 'Error',
            message: 'Permission denied for create document. please contact owner.',
          });
        } else {
          this.$router.push({
            name: 'upload-documents',
          });
        }
      },
      fetchingSelectedDelete({ data }) {
        this.selected_document = [];
        this.selected_document = data;
      },
      checkCondition() {
        if (!this.checkPermissions('deleteDocument')) {
          this.$notify.error({
            title: 'Error',
            message: 'Permission denied for delete document. Please contact owner.',
          });
        } else {
          this.selected_document.forEach((e) => {
            const authenticatedUser = this.getAuthenticatedUser && this.getAuthenticatedUser._id;
            if (e && e.created_by && authenticatedUser && e.created_by === authenticatedUser) {
              this.centerDialogVisible = true;
            } else if (
              e &&
              e.created_by &&
              authenticatedUser &&
              e.created_by !== authenticatedUser
            ) {
              this.dialogVisibility = true;
            } else {
              this.centerDialogVisible = true;
            }
          });
        }
      },
      async selectedDocumentDelete() {
        this.centerDialogVisible = false;
        this.is_documentDelete = true;
        this.setLoading();
        this.selected_document.forEach(async (e, index) => {
          if (e.document_status == 'ARCHIVED') {
            this.isVisible = true;
            if (e && this.getAuthenticatedUser && e.created_by === this.getAuthenticatedUser._id) {
              let document_id = e._id;
              await this.$store.dispatch('documents/parmanentdelete', {
                document_id,
              });
              if (index == this.selected_document.length - 1) {
                this.$notify.success({
                  title: 'Success',
                  message: 'Documents deleted successfully',
                });
              }
            }
          } else {
            if (e && this.getAuthenticatedUser && e.created_by === this.getAuthenticatedUser._id) {
              this.loading = true;
              let document_id = e._id;
              await this.$store.dispatch('documents/archiveDocument', {
                document_id,
              });
              if (index == this.selected_document.length - 1) {
                this.$notify.success({
                  title: 'Success',
                  message: 'Documents deleted successfully',
                });
              }
            }
          }
          this.setLoading();
        });
      },

      checkPermissions(permission) {
        if (this.getUserType && this.getUserType.permissionSet) {
          return this.getUserType.permissionSet.includes(permission) ? true : false;
        } else {
          return true;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .all-documents-view {
    .search {
      position: relative;
      @media (max-width: 991.98px) {
        width: 100%;
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
    .select {
      position: relative;
      @media (max-width: 991.98px) {
        width: 100%;
        margin-top: 10px;
        margin-bottom: 10px;
      }
    }
    .title {
      letter-spacing: 0.019em;
    }
    .text-secondary-sent {
      font-size: 10px !important;
      font-weight: 400 !important;
      line-height: 14px !important;
      text-align: left !important;
      color: #439ffc !important;
    }
    .text-secondary {
      font-size: 14px !important;
      font-weight: 400 !important;
      text-align: left !important;
      color: #6c757d !important;
    }
    .doc-subs {
      font-size: 10px;
      margin-top: -13px;
      font-weight: 300;
      text-align: right;
      margin-right: 9%;
    }
    .doc-sub {
      font-size: 10px;
      font-weight: 300;
      line-height: 14px;
      text-align: left;
    }
    .doc-title {
      cursor: pointer;
      font-size: 14px;
      font-weight: 300;
      line-height: 14px;
      text-align: left;

      color: #6c757d !important;
    }
    .check-font {
      color: #6c757d !important;
    }
    .circle {
      position: relative;
      padding-left: 20px;
      text-transform: capitalize;
      font-size: 14px;
      &::after {
        background: #635e5e;
        content: '';
        position: absolute;
        top: 4px;
        left: 0;
        height: 10px;
        width: 10px;
        display: inline-block;
        border-radius: 50%;
      }
      &.completed::after {
        background: #08ad36;
      }
      &.draft::after {
        background: #f19203;
      }
      &.sent::after {
        background: #2f80ed;
      }
      &.active::after {
        background: #635e5e;
      }
      &.expired::after {
        background: #f03232;
      }
    }
    .custom-pagination {
      text-align: center;
      margin-top: 5px;
    }
  }

  ::v-deep .el-table--scrollable-x .el-table__body-wrapper {
    overflow-x: auto;
    scrollbar-width: thin;
  }
</style>

<style lang="scss">
  .doc-modal {
    .el-dialog__header {
      .el-dialog__title {
        text-transform: uppercase;
      }
    }
    .error {
      color: red;
    }
  }
  .import-dropdown-btn {
    margin-left: 10px;
    height: 40px;
    .el-button {
      height: 100%;
      font-size: 14px;
      span {
        padding: 0 10px;
      }
    }
  }
  .import-dropdown-btn-menu {
    .el-dropdown-menu__item {
      display: flex;
      img {
        width: 25px;
        height: 25px;
        padding: 3px;
        background: #f7f7f7;
        border-radius: 10px;
      }
      span {
        margin-top: -2px;
        margin-left: 10px;
      }
    }
  }
  .DialogueStyle {
    margin-top: 50px;
  }
</style>

<style>
  .scaling-button {
    transform: scale(1);
    transition: transform 0.3s;
    height: 32px;
  }

  .scaling-button:hover {
    transform: scale(1.03);
  }
</style>
<style scoped>
  .import-dropdown-btn .el-button {
    height: 100%;
    font-size: 14px;
    position: relative !important;
    bottom: 10px !important;
  }
  .create-doc {
    position: relative;
    bottom: 5px;
  }
  @media (max-width: 768px) {
    .ml-0 {
      margin-left: 0 !important;
    }
    .mb-2 {
      margin-bottom: 10px;
    }
  }
</style>
